import { Thumbnail } from '@/interfaces/thumbnail.interface';

export default (thumbnail: Thumbnail, size: number): string => {
  const thumbUrl = `${process.env.VUE_APP_BASE_URL}${thumbnail.location}`;

  return thumbUrl.replace('/700/', `/${size}/`);
};
